export const issueStateFilterValues = {
  NEW: 'status = NEW',
  IN_PROGRESS: 'status = IN_PROGRESS',
  RESOLVED: 'status = RESOLVED',
  REJECTED: 'status = REJECTED',
} as const;

export type IssueStateFilterValue =
  (typeof issueStateFilterValues)[keyof typeof issueStateFilterValues];
